// extracted by mini-css-extract-plugin
module.exports = {"header":"panel_header__1xsRV","body":"panel_body__30Hxe","left":"panel_left__2_sV8","right":"panel_right__3sV3I"};